import DispensaryCategoryPage from 'src/dispensary/category';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';
import { getCacheableSearchVisibilityServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getCacheableSearchVisibilityServerSideProps;

export default withLayout(DispensaryCategoryPage, MainDispensaryLayout);
